<template>
  <div>
    <div class="detail">已成功开具 {{num}} 张发票  (合计 ￥{{amountNum| formatMoney}} )</div>
    <div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="createTime" label="申请时间" min-width="100px"> 
          <template slot-scope="scope">
            <div>
              {{scope.row.createTime | format('YYYY-MM-DD HH:mm:ss') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="companyName" label="发票抬头" show-overflow-tooltip  min-width="120px"> 
          <template slot-scope="scope">
            <span>
              {{scope.row.companyName || '---' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="typeStr" label="发票类型" show-overflow-tooltip min-width="120px"> 
          <template slot-scope="scope">
            <span>
              {{scope.row.typeStr || '---' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="发票内容" min-width="80px">
          <template>
            <span>平台服务费</span>
          </template>  
        </el-table-column>
        <el-table-column prop="amount" label="申请金额" min-width="80px">
          <template slot-scope="scope">
            <div class="valueamount">￥{{scope.row.amount | formatMoney}}</div>
          </template>  
        </el-table-column>
        <el-table-column prop="amount" label="开票金额" min-width="80px">
          <template slot-scope="scope">
            <div class="valueamount" v-if="scope.row.invoiceInfoAmount">￥{{scope.row.invoiceInfoAmount | formatMoney}}</div>
            <div class="valueamount" v-else>---</div>
          </template>  
        </el-table-column>
        <!-- <el-table-column prop="invoiceNum" label="发票号码"> </el-table-column> -->
        <el-table-column prop="statusStr" label=" 发票状态" min-width="80px">
          <template slot-scope="scope">
            <span v-if="scope.row.rejectReason&&[4,5].includes(scope.row.status)&&scope.row.statusStr">
              <el-tooltip class="item" effect="light" :content="scope.row.rejectReason" placement="top">
                <span> <i class="iconfont icon-xingzhuang"></i> </span>
              </el-tooltip>
            </span>
            <span v-if="[4,5].includes(scope.row.status)">{{scope.row.statusStr||'---'}}</span>
            <span v-if="![4,5].includes(scope.row.status)">{{scope.row.statusStr||'---'}}</span>
          </template>  
        </el-table-column>
        <el-table-column label="操作"   width="120px">
          <template slot-scope="scope">
            <el-button @click="jumpDetail(scope)" type="text" class="textbtn">详情</el-button>
            <el-button v-if="scope.row.status==3&&[3,4].includes(scope.row.type)" type="text" class="textbtn">
              <a :href="`${onlineUrl}/mk-leads/common/attach/download-file/${scope.row.attach.hashCode}`">下载发票</a>
            </el-button>
            <el-button v-if="scope.row.status==1" @click="withdraw(scope)" type="text" class="textbtn">撤回</el-button>
          </template>  
        </el-table-column>
      </el-table>
    </div>
    <div class="pagetionStyle"> 
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="curPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes,prev,pager,next, jumper"
        :total="totalNum"
        ref="pagina"
        >
      </el-pagination>
    </div>
  </div>
</template>
  
<script>
import {invoiceRecord,invoiceRecordWithdraw,invoiceRecordListNum} from "@/utils/api/invoice"
import { downloadFileFun } from '@/utils/common.js'
import { onlineUrl } from '@/utils/config.js'
export default {
  data() {
    return {
      tableData: [],
      totalNum:0,
      pageSize:10,
      curPage:1,
      num:0,
      amountNum:0,
      onlineUrl:onlineUrl
    };
  },
  mounted(){
    this.getInvoiceRecord()
    this.getinvoiceRecordListNum()
  },
  methods: {
    getInvoiceRecord(){
      const parmas={
        "curPage": this.curPage,
        "pageSize": this.pageSize,
        "attribute": "",
        "sortType": 0
      }
      invoiceRecord(parmas).then(res=>{
        if(res.rspResult.bizCode==200){
          this.tableData=res.rspPageData.list
          this.totalNum=res.rspPageData.totalNum
        }
      })
    },
    // 获取总个数，总金额
    getinvoiceRecordListNum(){
      invoiceRecordListNum().then((res)=>{
        if(res.rspResult.bizCode==200){
          this.num=res.data.num
          this.amountNum=res.data.amountNum
          // this.totalNum=res.rspPageData.totalNum
        }
      })
    },
    // 翻页
    handleSizeChange(val) {
      this.pageSize=val
      this.handleCurrentChange(1)
      this.clickPage=1
    },
    // 当前页
    handleCurrentChange(val) {
      this.curPage=val
      this.getInvoiceRecord()
    },
    // 跳转详情
    jumpDetail(scope){
      this.$router.push({
        name: "const-center-invoice-detail",
        query: {
          id:scope.row.id
        },
      });
    },
    // 撤回
    withdraw(scope){
      const parmas={
        id:scope.row.id
      }
      invoiceRecordWithdraw(parmas).then(res=>{
        console.log(res)
        if(res.rspResult.bizCode==200){
          this.$message.success(res.rspResult.message);
          this.handleSizeChange(this.pageSize)
        }
      })
    },
    // 下载
    donwload(scope){
      console.log(scope)
      // return downloadFileFun(`${onlineUrl}/${scope.row.attach.url}`)
      // return downloadFileFun(`${onlineUrl}/mk-leads/common/attach/download-file/${scope.row.attach.url}`)
      // return downloadFileFun(`${onlineUrl}/attachment/download/attach/${scope.row.attach}`)
    }
  },
};
</script>

<style lang="scss" scoped>
.pagetionStyle{
  text-align: center;
  margin-top: 30px;
  ::v-deep .is-background{
    .btn-prev,.btn-next,.el-pager>li{
      background: #FFFFFF;
      border: 1px solid #CFD5DF;
      border-radius: 6px;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active{
      background-color: #066EB7 !important;
    }
    // .btn-prev{
    //   background: #FFFFFF;
    //   border: 1px solid #CFD5DF;
    //   border-radius: 6px;
    // }
  }
}
.detail{
  margin: 20px 0;
  color: #16181A;
  font-size: 14px;
}
.valueamount{
  color: #FF7F2A;
}
.icon-xingzhuang{
  font-size: 12px;
  margin-right: 4px;
}
.textbtn{
  color: #318CED;
}
</style>